import { render, staticRenderFns } from "./CompanyVersionAssignment.vue?vue&type=template&id=01328bad&scoped=true"
import script from "./CompanyVersionAssignment.vue?vue&type=script&lang=js"
export * from "./CompanyVersionAssignment.vue?vue&type=script&lang=js"
import style0 from "./CompanyVersionAssignment.vue?vue&type=style&index=0&id=01328bad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01328bad",
  null
  
)

export default component.exports